import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAppApi } from '@/lib/api';
import { StaffShell } from '@/components';
import { platformRoutes } from './routes';
import { activeNavPath } from './lib/nav';
import { allowed } from './lib/access';

/**
 * Console shell (StaffShell / twreact AppShell): grouped sidebar (Overview, Merchants, Marketplace,
 * Finance, Platform) from lg, drawer below, and a FootNav with the four busiest queues on phones.
 */
export default function PlatformLayout({ admin, onSignedOut }) {
  const nav = useNavigate();
  const loc = useLocation();
  const { fetchApi } = useAppApi();

  const active = activeNavPath(loc.pathname, platformRoutes);
  const visible = platformRoutes.filter((r) => r.nav !== false && allowed(admin.permissions, r.permission));
  const current = visible.find((r) => r.path === active);
  const sidebarItems = visible.map((r) => ({
    id: r.path,
    label: r.label,
    href: r.path,
    icon: <r.icon size={18} aria-hidden />,
    group: r.group,
    active: r.path === active,
  }));
  const footItems = visible.filter((r) => r.foot).map((r) => ({
    id: r.path,
    label: r.foot,
    to: r.path,
    icon: <r.icon size={20} aria-hidden />,
    active: r.path === active,
  }));

  const logout = async () => {
    try { await fetchApi('platformLogout'); } catch { /* cookie may already be gone */ }
    onSignedOut();
    nav('/login', { replace: true });
  };

  return (
    <StaffShell
      brand={
        <span className="min-w-0">
          <span className="block font-semibold truncate">MerchantPro Cloud</span>
          <span className="block text-micro opacity-70 truncate">Platform admin · {admin.email}</span>
        </span>
      }
      pageTitle={current ? current.label : 'MerchantPro Cloud'}
      nav={sidebarItems}
      foot={footItems}
      user={{ name: 'Super Admin', email: admin.email }}
      onLogout={logout}
    >
      <Outlet />
    </StaffShell>
  );
}
